<template>
  <AppConfirmDialog
    v-if="appConfirmState.options"
    :model-value="appConfirmState.visible"
    :title="appConfirmState.options.title ?? t('common.dialogs.confirmTitle')"
    :message="appConfirmState.options.message"
    :detail="appConfirmState.options.detail"
    :highlight="appConfirmState.options.highlight"
    :variant="appConfirmState.options.variant ?? 'info'"
    :confirm-label="appConfirmState.options.okText ?? t('common.dialogs.confirm')"
    :cancel-label="appConfirmState.options.cancelText ?? t('common.dialogs.cancel')"
    @update:modelValue="onVisibilityChange"
    @confirm="resolveAppConfirm(true)"
    @cancel="resolveAppConfirm(false)"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import AppConfirmDialog from './AppConfirmDialog.vue'
import { appConfirmState, resolveAppConfirm } from './confirmState'

const { t } = useI18n()

function onVisibilityChange(value: boolean) {
  if (!value) {
    resolveAppConfirm(false)
  }
}
</script>
